import PriceFinder, {
  PricingIntlProvider,
} from "@atlassiansox/bxp-price-finder";
import React from "react";
import useGeoCurrency from "./use-geo-currency";
import { AnalyticsListener } from "@atlaskit/analytics-next";
import tracking from "../../../utils/tracking";
import { fetchPricing } from "../../../utils/get-catalog-client";

const sendAnalytics = (analytic) => {
  const eventName =
    analytic.payload && analytic.payload.name
      ? analytic.payload.name
      : "price-finder-component-track-event";

  let eventPayload = analytic.payload;
  if (analytic.context[0]) {
    eventPayload = Object.assign(analytic.context[0], analytic.payload);
  }

  if (eventPayload.name !== undefined) {
    delete eventPayload.name;
  }

  try {
    tracking.trackEvent(eventName, eventPayload);
  } catch (e) {
    console.log(eventName, "AnalyticsListener did not find tracker");
  }
};

const LANGS = [
  "de",
  "en",
  "es",
  "fr",
  "it",
  "ko",
  "hu",
  "nl",
  "ja",
  "pl",
  "br",
  "ru",
  "zh",
];

const PriceFinderContainer = ({
  basePriceFinderConfig,
  priceFinderConfig,
  productPlans,
  signupURL,
  contactURL,
  // planFeatureMessages,
}) => {
  // get union of all config keys (base and specific product config)
  const configKeys = new Set();
  const allKeys = Object.keys(basePriceFinderConfig).concat(
    Object.keys(priceFinderConfig)
  );

  for (const allConfigKey of allKeys) {
    configKeys.add(allConfigKey);
  }

  let integratedPriceFinderConfig = {};
  for (const configKey of configKeys) {
    integratedPriceFinderConfig[configKey] =
      priceFinderConfig[configKey] || basePriceFinderConfig[configKey];
  }

  const {
    productKey,
    defaultUnitCount,
    halpSignupURLs,
    // planDescHeaderMessages,
    unitLimitFree,
    unitMinEnterprise,
    hideBillingCycleSelector,
    showFirstFlatRateTier,
    forceCurrencyISOCode,
  } = integratedPriceFinderConfig;

  const docLang = document.documentElement.lang;

  const getLocalizedKey = (keyName, lang) =>
    lang === "en" ? keyName : `${keyName}_${lang}`;

  // const localizedPlanDescHeaderMessagesKey = getLocalizedKey(
  //   "planDescHeaderMessages",
  //   docLang
  // );

  // const localizedPlanDescHeaderMessages =
  //   integratedPriceFinderConfig[localizedPlanDescHeaderMessagesKey] ||
  //   planDescHeaderMessages;

  for (let idx = 0; idx < productPlans.length; idx++) {
    const productPlan = productPlans[idx];

    // UNUSED currently!
    // productPlan.planDescHeaderMessage =
    //   localizedPlanDescHeaderMessages[idx] || "";

    productPlan.planDescHeaderMessage =
      priceFinderConfig[
        getLocalizedKey("planHeaderMessage" + (idx + 1), docLang)
      ] || "";

    // featureMessages are UNUSED currently!
    // const featureMessages = planFeatureMessages[idx];
    // for (const messageObj of featureMessages) {
    //   messageObj.message =
    //     messageObj[getLocalizedKey("message", docLang)] ||
    //     messageObj.message ||
    //     "";
    // }

    // productPlan.planFeatureMessages = featureMessages;

    // UNUSED
    // for (let planFeatureMessage of productPlan.planFeatureMessages) {
    //   planFeatureMessage.isLabelPresent =
    //     planFeatureMessage.isLabelPresent === "true";
    // }

    const coreFeaturesStartIdx = idx * 6 + 1;
    const planCoreFeatures = [];

    for (
      let coreFeatureIdx = coreFeaturesStartIdx;
      coreFeatureIdx < coreFeaturesStartIdx + 6;
      coreFeatureIdx++
    ) {
      planCoreFeatures.push(
        priceFinderConfig[
          getLocalizedKey("coreFeature" + coreFeatureIdx, docLang)
        ]
      );
    }

    const planCoreFeatureObjs = [];
    for (const coreFeatureText of planCoreFeatures) {
      if (coreFeatureText && coreFeatureText !== "") {
        const regex =
          / {(?<modalTargetId>[a-zA-Z0-9]{8})?:(?<isLabelPresent>true|)}$/;

        const match = coreFeatureText.match(regex);
        if (!match) {
          planCoreFeatureObjs.push({ message: coreFeatureText });
        } else {
          const { modalTargetId, isLabelPresent } = match.groups;

          planCoreFeatureObjs.push({
            message: coreFeatureText.replace(regex, ""),
            modalTargetId,
            isLabelPresent,
          });
        }
      }
    }

    productPlan.planFeatureMessages = planCoreFeatureObjs;
  }

  const messages = {};
  for (const lang of LANGS) {
    const keysForLang = Object.keys(integratedPriceFinderConfig).filter((key) =>
      lang === "en" ? !key.match(/_[a-z]{2}$/) : key.endsWith("_" + lang)
    );

    const langMessages = {};
    for (const keyForLang of keysForLang) {
      langMessages[keyForLang.replace("_" + lang, "")] =
        integratedPriceFinderConfig[keyForLang];
    }

    messages[lang] = langMessages;
  }

  const geoCurrency = useGeoCurrency();

  if (!geoCurrency.isPending) {
    return (
      <AnalyticsListener onEvent={sendAnalytics}>
        <PricingIntlProvider
          locale={document.documentElement.lang}
          messages={messages[document.documentElement.lang]}
        >
          <PriceFinder
            productKey={productKey}
            defaultUnitCount={parseInt(defaultUnitCount)}
            signupURL={signupURL}
            halpSignupURLs={halpSignupURLs}
            contactURL={contactURL}
            productPlans={productPlans}
            currencyISOCode={
              forceCurrencyISOCode !== undefined && forceCurrencyISOCode != ""
                ? forceCurrencyISOCode
                : geoCurrency.value
            }
            unitLimitFree={parseInt(unitLimitFree)}
            unitMinEnterprise={parseInt(unitMinEnterprise)}
            hideBillingSelector={hideBillingCycleSelector === "true"}
            fetchPricing={fetchPricing}
            showFirstFlatRateTier={showFirstFlatRateTier === "true"}
          />
        </PricingIntlProvider>
      </AnalyticsListener>
    );
  } else {
    return null;
  }
};

export default PriceFinderContainer;
